import { forwardRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import { ContractType, contractType1Enum } from '../../modules/contracts';
import {
  genCostAccountingTableObj2,
  genLevel1CodeList,
  genLevel1Data,
  genLevel2Data,
  genLevel3Data,
} from '../../util/utils';
import CostAccountingTableComponent2 from './CostAccountingTableComponent2';
import TableComponent3 from './TableComponent3';
import TableComponent5 from './TableComponent5';

const StyledDiv = styled.div``;

interface SOVReportComponentProps {
  projectName: string;
  data: any;
  contractType1: ContractType;
  contract?: any;
}

const SOVReportComponent = forwardRef<
  HTMLInputElement,
  SOVReportComponentProps
>(({ projectName, data, contractType1, contract }, ref) => {
  const [level1Data, setLevel1Data] = useState<any>();
  const [level2Data, setLevel2Data] = useState<any[]>([]);
  const [level3Data, setLevel3Data] = useState<any[]>([]);
  const [costAccountingTableObj, setCostAccountingTableObj] = useState<any>();

  useEffect(() => {
    let topConstructionCodeLevel = 1;
    if (contractType1 !== contractType1Enum.PRIME_CONTRACT)
      topConstructionCodeLevel = 2;

    const level1CodeList: any[] = genLevel1CodeList(
      data,
      topConstructionCodeLevel,
    );

    const _level1Data: any[] = genLevel1Data(data, topConstructionCodeLevel);

    setLevel1Data({ projectName, items: _level1Data });

    const _level2Data: any[] = genLevel2Data(data, projectName, level1CodeList);
    setLevel2Data(_level2Data);

    const tempArr: any[] = genLevel3Data(data, projectName, level1CodeList);
    setLevel3Data(tempArr);
    const _costAccountingTableObj: any = genCostAccountingTableObj2(
      _level1Data,
      contract.metaData,
    );
    setCostAccountingTableObj(_costAccountingTableObj);
  }, [data, projectName, contractType1, contract]);

  const data2Table = level2Data.map((_data, index) => (
    <TableComponent3 data={_data} type={2} key={index} />
  ));

  const data3Table = level3Data.map((_data, index) => (
    <TableComponent5 data={_data} type={3} key={index} />
  ));

  const getPageMargins = () => {
    return `
    @page { size: landscape; margin : 5mm 5mm 10mm 5mm; }
    @media all {
      .page-break {
        display: none;
      }
    }
    
    @media print {
      html, body {
        height: initial !important;
        overflow: initial !important;
        -webkit-print-color-adjust: exact;
      }
      .page-break {
        display: block;
        page-break-before: auto;
      }
    }
    `;
  };

  return (
    <StyledDiv ref={ref}>
      <style>{getPageMargins()}</style>
      {level1Data && level2Data && (
        <CostAccountingTableComponent2
          projectName={projectName}
          metaData={contract.metaData}
          costAccountingTableObj={costAccountingTableObj}
        />
      )}
      {level1Data && data2Table && data3Table && (
        <>
          <TableComponent5 data={level1Data} type={1} />
        </>
      )}
      <>{contractType1 === contractType1Enum.PRIME_CONTRACT && data2Table}</>
      <>{data3Table}</>
    </StyledDiv>
  );
});

export default SOVReportComponent;
